import { t } from 'i18next'

import { Icon } from '@/shared/components/icon'

export const CadastroCompradoresEmpty: React.FC = () => {
  return (
    <div className="mb-6 flex min-h-96 w-full flex-col items-center justify-center">
      <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-orange-100">
        <Icon name="blocks" className="h-10 w-10 text-orange-900" />
      </div>
      <h2 className="text-md mb-2 font-semibold text-neutral-700">
        {t('proposta:cadastro_compradores.empty_state.nada_encontrado')}
      </h2>
      <p className="font-nunito mb-6 text-sm text-neutral-800">
        {t('proposta:cadastro_compradores.empty_state.cadastre_comprador')}
      </p>
    </div>
  )
}
